import { useNavigate } from "react-router-dom";
import { useBranch } from "@/context/BranchContext";
import { roleMeta } from "@/config/roles";

export default function NoPermissionsPage() {
  const navigate = useNavigate();
  const { employee, logout } = useBranch();
  const role = employee ? roleMeta(employee.role) : null;

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center bg-background-50 rounded-card border border-background-200 p-8 animate-fade-slide-up">
        <div className="mx-auto w-20 h-20 rounded-full bg-secondary-100 flex items-center justify-center">
          <i className="ri-shield-keyhole-line text-4xl text-secondary-700"></i>
        </div>

        <h2 className="mt-5 text-lg font-bold text-foreground-900 leading-relaxed">
          لا توجد صلاحيات تشغيلية ممنوحة لحسابك. تواصل مع صاحب المحل.
        </h2>

        {employee ? (
          <div className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-100 border border-background-200">
            {role ? <i className={`${role.icon} text-sm text-foreground-500`}></i> : null}
            <span className="text-xs font-semibold text-foreground-700">{employee.name}</span>
            {role ? (
              <span className="text-xs text-foreground-400">— {role.label}</span>
            ) : null}
          </div>
        ) : null}

        <p className="mt-4 text-sm text-foreground-500 leading-relaxed">
          يمكنك فقط الوصول إلى الإشعارات وحسابك. لأي صلاحية إضافية، تواصل مع صاحب المحل.
        </p>

        <div className="mt-6 flex flex-col sm:flex-row gap-2.5">
          <button
            type="button"
            onClick={() => navigate("/account", { replace: true })}
            className="flex-1 h-12 rounded-btn border border-background-300 text-foreground-700 text-sm font-bold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="inline-flex items-center gap-2">
              <i className="ri-user-3-line text-lg"></i>
              حسابي
            </span>
          </button>
          <button
            type="button"
            onClick={handleLogout}
            className="flex-1 h-12 rounded-btn bg-primary-500 text-white text-sm font-bold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="inline-flex items-center gap-2">
              <i className="ri-logout-box-r-line text-lg"></i>
              تسجيل الخروج
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}